import { useQuery } from "@tanstack/react-query";
import { api, type Api } from "@api/bot-base-api-request";
import {
  BotWalletSupportedChain,
  Wallet,
  WalletType,
} from "@/providers/wallet";
import { WalletTotalPnl } from "./types";

const POSITIONS_QUERY_KEY = "positions-aggregated-bot";

const fetchBotAggregatedPositions = async (
  api: Api,
  userId?: string,
  wallet?: Wallet
): Promise<WalletTotalPnl> => {
  return api
    .get("aggregatedPNL", {
      searchParams: {
        userId: userId ?? "",
        walletAddress: wallet?.address ?? "",
        chainId:
          wallet?.walletType === WalletType.ETH
            ? BotWalletSupportedChain.ETH
            : BotWalletSupportedChain.SOL,
      },
    })
    .json();
};

const useGetBotAggregatedPositions = (userId?: string, wallet?: Wallet) => {
  return useQuery({
    queryKey: [POSITIONS_QUERY_KEY, userId, wallet?.address, wallet?.chain],
    queryFn: async () => fetchBotAggregatedPositions(api, userId, wallet),
    enabled: !!userId && !!wallet,
  });
};

export { useGetBotAggregatedPositions };
